import React, { useState, useEffect } from 'react';
import "./Works.scss";

const Works = () => {
  const [heightOver, setHeightOver] = useState(false);
  const [heightOver2, setHeightOver2] = useState(false);
  useEffect(() => {
    const scrollAction = () => {
      if (1800 < window.scrollY) {
        setHeightOver(true);
      }
    };
    const scrollAction2 = () => {
      if (1800 < window.scrollY) {
        setHeightOver2(true);
      }
    };
    window.addEventListener("scroll", scrollAction, {
      capture: false,
      passive: true,
    });
    window.addEventListener("scroll", scrollAction2, {
      capture: false,
      passive: true,
    });
    scrollAction();
    scrollAction2();
    return () => {
      window.removeEventListener("scroll", scrollAction);
      window.removeEventListener("scroll", scrollAction2);
    };
  }, []);

  let url = "okamurashop.php.xdomain.jp";

  return (
    <div className="works-container">
      <div className="title-box">
        <h2 className={heightOver ? "title-h2" : "scroll"}>Works</h2>
        <p className={heightOver ? "title-p" : "scroll"}>ポートフォリオ</p>
        <div className={heightOver ? "title-back" : "scroll"}></div>
        <div className={heightOver ? "title-drop" : "scroll"}></div>
        <div className={heightOver ? "title-wave" : "scroll"}></div>
        <div className={heightOver ? "title-wave2" : "scroll"}></div>
      </div>
      <div className={heightOver2 ? "works-wrapper" : "scroll"}>
        <div className="work-box">
          <video src="/videos/video2.mov" controls className="video"></video>
          <a href="https://twitter-app-cce4a.web.app">React、Typescript、Firebase、material-uiを利用したツイッタークローンアプリ</a>
          <div className="work-info-wrapper">
          <p>概要</p>
          <p>Youtubeやudemyに公開されている様々なツイッタークローンアプリの作り方を参考にして作成いたしました。
          ReactHooks、useEffect、ReduxtoolkitなどReactとRedux基礎を固め、チーム開発を想定してTypescriptも使用し、Firebase認証機能やDatabse、FirebaseStorageでバックエンドの処理を学習することができました。
          Email + Password認証、Google認証、パスワードリセット機能、ユーザープロフィールの登録などが可能です。</p>
          <p>苦労した点</p>
          <p>Firebaseがver9になり最新の情報が少なかったため、データベース関連やホスティングに関する記述を変更するのが大変でした。Reactに関してもエラーに対応する情報が限られており、海外のサイトを参考に開発を進めました。</p>
          <p>使用した技術</p>
          <p>React.js・Redux・Typescript・Firebase・HTML・CSS・Material-ui・Adobe XD</p>
          </div>
        </div>
        <div className="work-box">
        <video src="/videos/video3.mov" controls className="video"></video>
          <a href="https://climup-a653d.web.app">React、Firebaseを利用した架空のジムサイト</a>
        <div className="work-info-wrapper">
          <p>概要</p>
          <p>ツイッタークローンアプリの作成で得た知識のアウトプットとして架空のwebサイトを作成いたしました。ReactHooksを用いたUIの変更、React-router-domによる画面遷移、Email.jsによるメール送信、FirebaseDatabaseによるデータの受け渡しなどを主に学習しました。Stateで会員の種類を保持し、決済の際に値段とメールの内容を変更することもできます。
          </p>
          <p>苦労した点</p>
          <p>技術のアウトプットということでフルスクラッチ開発したので、作品のクオリティは低いですが苦労しました。React-router-domがv5からv6にアップデートすることによるコードの修正、即時関数を用いてStateの値に合わせてJSXの内容を変更、初めてEmail.jsを利用したので処理が慣れなかったりと、使用技術以上に調べる能力がより向上したと思います。</p>
          <p>使用した技術</p>
          <p>React.js・Firebase・HTML・CSS・Material-ui・Email.js・Adobe XD
          </p>
        </div>
        </div>
        <div className="work-box">
        <video src="/videos/video1.mov" controls className="video"></video>
          <a href="http://okamurashop.php.xdomain.jp">PHP、MySQLを利用したECサイト</a>
        <div className="work-info-wrapper">
          <p>概要</p>
          <p>MySQLを用いてログイン機能を実装する記事を参考にして作成いたしました。MySQLの基礎であるテーブルの作成、データベース管理、fetchによるデータの取得、DELETEによるデータ削除などCRUD機能の理解を深め、sessionやPOSTといったHTMLでのデータ送信も復習しました。mb_send_emailでのメール送信、商品検索機能なども実装いたしました。</p>
          <p>苦労した点</p>
          <p>ご利用ガイドや会社概要など細かなページも作成したので、ページデザインやレスポンシブデザインが大変でした。ログインの有無、カート内の商品の有無などの条件分岐も複雑で、PDOやsetAttributeなどMySQLに関する記述の理解にも時間がかかりました。</p>
          <p>使用した技術</p>
          <p>PHP・MySQL・HTML・CSS・MAMP・XFREE・Adobe XD</p>
        </div>
        </div>
      </div>


      </div>
  )
}

export default Works;